/* Al pulsar la barra de valoracion, bajar a las resenas.
 *
 * El destino se busca por .sds-rv (la seccion "what producers say"). Si una
 * ficha no la tuviera, el boton no hace nada en vez de saltar a ningun sitio:
 * la barra sigue mostrando la nota, que es lo que mas aporta.
 *
 * Se resta la altura de la cabecera porque es sticky: sin eso, la seccion
 * aterriza debajo del menu y parece que el salto se ha quedado corto.
 */
(function () {
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-sds-rating-jump]');
    if (!boton) return;

    var destino = document.querySelector('.sds-rv');
    if (!destino) return;

    e.preventDefault();

    var cabecera = document.querySelector('sticky-header, .header-wrapper, .section-header');
    var alto = cabecera ? cabecera.getBoundingClientRect().height : 0;
    var y = destino.getBoundingClientRect().top + window.pageYOffset - alto - 16;

    var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: y, behavior: suave ? 'smooth' : 'auto' });
  });
})();
